import { useLang } from "../hooks/useLanguage";
import { Reveal } from "./Reveal";

const Criteria = () => {
  const { t } = useLang();
  return (
    <section id="criteria" className="bg-stone text-[#202020] py-24 md:py-32" data-testid="criteria-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <Reveal className="lg:col-span-7">
            <p className="label-caps">{t.UI.criteriaLabel}</p>
            <h2 className="mt-4 font-serif-lux font-light text-[clamp(2rem,4.5vw,3.4rem)] leading-[1.08] tracking-tight">
              {t.UI.criteriaTitle}
            </h2>
          </Reveal>
          <Reveal className="lg:col-span-5" delay={0.1}>
            <p className="text-smoke leading-relaxed max-w-md lg:ms-auto">{t.UI.criteriaBody}</p>
          </Reveal>
        </div>
        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 border-t hairline-light">
          {t.CRITERIA.map((c, i) => (
            <Reveal key={c.label} delay={(i % 3) * 0.07} className="h-full">
              <div
                className="h-full border-b md:border-e hairline-light p-8 lg:p-10"
                data-testid={`criteria-panel-${i + 1}`}
              >
                <p className="label-caps">{c.label}</p>
                <p className="mt-6 font-serif-lux text-4xl lg:text-5xl font-light text-[#141414]">{c.value}</p>
                <p className="mt-4 text-sm text-smoke leading-relaxed">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Criteria;
